import React from 'react';

import ManageCMDBDiscoveredApps from '../../features/ManageCMDBDiscoveredApps/manageCMDBDiscoveredApps';

/**
 * Manage CMDB Component
 */
function ManageCMDB() {
  return <ManageCMDBDiscoveredApps />;
}

export default ManageCMDB;
